import FormLabel from "@mui/joy/FormLabel";
import FormControl from "@mui/joy/FormControl";
import FormHelperText from "@mui/joy/FormHelperText";
import Tooltip from "@mui/joy/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Controller } from "react-hook-form";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import Typography from "@mui/joy/Typography";
import { SxProps } from "@mui/joy/styles/types";

interface Props {
  name: string;
  label?: string;
  control: any;
  infoText?: string;
  helperText?: string;
  placeholder?: string;
  portalId?: string;
  error?: string;
  required?: boolean;
  min?: Date;
  disabled?: boolean;
  readOnly?: boolean;
  showTimeInput?: boolean;
  outerSx?: SxProps;
  dateFormat?: string;
}

const DateInput = ({
  name,
  label,
  infoText,
  control,
  placeholder,
  portalId,
  error,
  helperText,
  readOnly,
  min,
  required,
  dateFormat,
  showTimeInput,
  outerSx,
  disabled = false,
  ...props
}: Props) => {
  const today = new Date();
  const maxDate = new Date();
  maxDate.setFullYear(today.getFullYear() + 100);
  return (
    <FormControl
      key={name}
      sx={[
        {
          width: "100%",
        },
        ...(Array.isArray(outerSx) ? outerSx : [outerSx]),
      ]}
      size="sm"
      error={!!error}
    >
      {label && (
        <FormLabel
          sx={{
            fontSize: "sm",
            fontWeight: "lg",
            mb: 1,
          }}
          required={required}
        >
          {infoText && (
            <Tooltip
              title={infoText}
              sx={{
                maxWidth: "250px",
              }}
              arrow
              placement="right"
            >
              <InfoOutlinedIcon
                sx={{
                  fontSize: 15,
                  mr: 0.5,
                }}
              />
            </Tooltip>
          )}

          {label}
        </FormLabel>
      )}

      <Controller
        control={control}
        name={name}
        render={({ field: { onBlur, ref, onChange, value } }) => (
          <DatePicker
            {...props}
            selected={value}
            value={value}
            readOnly={readOnly}
            onBlur={onBlur}
            ref={(elem) => {
              elem && ref((elem as any)?.input);
            }}
            disabled={disabled}
            onChange={(date) => onChange(date)}
            placeholderText={placeholder}
            minDate={min || undefined}
            popperPlacement="bottom"
            maxDate={maxDate}
            showTimeInput={showTimeInput}
            dateFormat={dateFormat ? dateFormat : showTimeInput ? "MM/dd/yyyy hh:mm a" : "MM/dd/yyyy"}
            showIcon
            fixedHeight
            icon={<CalendarMonthOutlinedIcon size="sm" />}
            portalId={portalId}
          />
        )}
      />

      {helperText && <Typography sx={{ mt: 0.6, fontSize: "xs", color: "neutral.700" }}>{helperText}</Typography>}

      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};
export default DateInput;
